import * as React from "react";
import { BoxProps } from "../../types";

import "./BoxStyles.scss";

/**
 * Flex container utility component. A thin wrapper around a `<div>` with flex layout helpers.
 *
 * @example
 * ```tsx
 * // Row layout with centered items
 * <Box flexDirection="row" justifyContent="center" alignItems="center" spacing={16}>
 *   <Button text="Cancel" />
 *   <Button text="Save" color="primary" />
 * </Box>
 *
 * // Column layout
 * <Box flexDirection="column" spacing={8}>
 *   <CPText>Label</CPText>
 *   <CPText textStyle="body">Value</CPText>
 * </Box>
 * ```
 */
const Box: React.FC<BoxProps> = ({
  children,
  className,
  flexDirection,
  justifyContent,
  alignItems,
  spacing,
  style,
  onClick,
  htmlAttributes,
}) => {
  return (
    <div
      {...htmlAttributes}
      className={`cp-box-base ${className ?? ""}`}
      style={{
        flexDirection,
        justifyContent,
        alignItems,
        lineHeight: "1.5",
        boxSizing: "border-box",
        display: "flex",
        gap: spacing ?? 0,
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Box;
